import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, ShoppingCart, Check } from 'lucide-react';
import { useCart } from '../context/CartContext';

// Cart sound effect
const playCartSound = () => {
  const audio = new Audio('data:audio/mp3;base64,SUQzBAAAAAAAI1RTU0UAAAAPAAADTGF2ZjU4Ljc2LjEwMAAAAAAAAAAAAAAA//tQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWGluZwAAAA8AAAACAAABhgC7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7//////////////////////////////////////////////////////////////////8AAAAATGF2YzU4LjEzAAAAAAAAAAAAAAAAJAAAAAAAAAAAAYZNLBruAAAAAAD/+1DEAAAGAAGn9AAAIwwKd/OMACQAABpAAAABQGCAIAh8EAQBAH/BAEAQBA4sIAgCAIHc+ZQEAXP/6gIAgCAJnn/pAEPBA1/84CgIAgGOD//lwGBsMsP/nkQGPgg+f+8MYgIJn+MMDAYGBQM8H//+DBg4f//5wcGIBAED///+UGIIgCDoGJgcf////h+c/////BgxiRq7/2AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//tQxAADwAABpAAAACAAADSAAAAE//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8=');
  audio.volume = 0.3;
  audio.play().catch(() => {});
};

const Packages = () => {
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const [addedItems, setAddedItems] = useState({});
  const [showPopup, setShowPopup] = useState(false);

  const deals = [
    {
      id: 1,
      title: 'מבצע מיוחד לזמן מוגבל 1+1',
      description: 'סה"כ 180 טבליות חזקות במיוחד',
      price: 449,
      badge: 'מבצע מיוחד!',
      badgeColor: 'bg-red-500',
      image: 'https://customer-assets.emergentagent.com/job_intimate-care-pro-1/artifacts/3z4x5pwu_5.png'
    },
    {
      id: 2,
      title: '3 יחידות במחיר מיוחד',
      description: 'סה"כ 270 טבליות חזקות במיוחד',
      price: 549,
      badge: 'הנמכר ביותר',
      badgeColor: 'bg-[#D97706]',
      image: 'https://customer-assets.emergentagent.com/job_intimate-care-pro-1/artifacts/fmorl2ql_1.png'
    },
    {
      id: 3,
      title: '180 טבליות + טיטאן ג\'ל',
      description: 'טיטאן ג\'ל לעיכוב שפיכה ותחושה מהנה יותר',
      price: 599,
      badge: null,
      badgeColor: null,
      image: 'https://customer-assets.emergentagent.com/job_intimate-care-pro-1/artifacts/tzix10i6_3.png'
    },
    {
      id: 4,
      title: '180 טבליות + ספריי השהיה',
      description: 'ספריי השהיה לעיכוב שפיכה הטוב בעולם',
      price: 699,
      badge: null,
      badgeColor: null,
      image: 'https://customer-assets.emergentagent.com/job_intimate-care-pro-1/artifacts/wftnrbqg_4.png'
    },
    {
      id: 5,
      title: '6 חבילות במחיר שלא יחזור!',
      description: 'סה"כ 540 טבליות חזקות במיוחד',
      price: 799,
      badge: 'המשתלם ביותר',
      badgeColor: 'bg-green-500',
      image: 'https://customer-assets.emergentagent.com/job_intimate-care-pro-1/artifacts/wepsurv0_2.png'
    },
    {
      id: 6,
      title: 'רוכשים 4 יחידות - מקבלים מתנה טיטאן ג\'ל',
      description: '4 יחידות Back 2 Game + טיטאן ג\'ל מתנה!',
      price: 689,
      badge: 'כולל מתנה!',
      badgeColor: 'bg-purple-500',
      image: 'https://customer-assets.emergentagent.com/job_intimate-care-pro-1/artifacts/tbr6krlj_6.png'
    }
  ];

  const handleButtonClick = (deal) => {
    if (addedItems[deal.id]) {
      // Already added - go to cart
      navigate('/cart');
    } else {
      // Add to cart
      addToCart({
        id: `deal-${deal.id}`,
        name: deal.title,
        description: deal.description,
        price: deal.price,
        image: deal.image,
        quantity: 1
      });
      
      playCartSound();
      setAddedItems(prev => ({ ...prev, [deal.id]: true }));
      setShowPopup(true);
      
      setTimeout(() => {
        setShowPopup(false);
      }, 2000);
    }
  };

  return (
    <div className="container py-8" data-testid="packages-page">
      {/* Popup */}
      {showPopup && (
        <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 bg-green-500 text-white px-8 py-4 rounded-2xl shadow-2xl flex items-center gap-3 animate-bounce">
          <Check className="w-6 h-6" />
          <span className="font-bold text-lg" style={{ fontFamily: 'Heebo, sans-serif' }}>נוסף לסל</span>
        </div>
      )}

      {/* Back Button */}
      <button
        onClick={() => navigate('/products')}
        className="flex items-center gap-2 text-[#2C3E2D] hover:text-[#D97706] transition-colors mb-8"
        data-testid="back-button"
      >
        <ArrowRight className="w-5 h-5" />
        <span className="font-medium">חזרה למוצרים</span>
      </button>

      {/* Title */}
      <h1 className="text-4xl md:text-5xl font-bold text-[#2C3E2D] text-center mb-10" style={{ fontFamily: 'Heebo, sans-serif' }} data-testid="packages-title">
        חבילות ומבצעים
      </h1>

      {/* Deals Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {deals.map((deal) => (
          <div
            key={deal.id}
            className={`bg-white rounded-2xl shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl hover:-translate-y-1 flex flex-col ${
              deal.badge === 'הנמכר ביותר' ? 'border-4 border-[#D97706]' : 'border border-stone-200'
            }`}
            data-testid={`deal-${deal.id}`}
          >
            {/* Badge */}
            {deal.badge ? (
              <div className={`${deal.badgeColor} text-white text-center py-2`}>
                <span className="font-bold text-lg" style={{ fontFamily: 'Heebo, sans-serif' }}>
                  {deal.badge}
                </span>
              </div>
            ) : (
              <div className="py-2 bg-transparent">
                <span className="font-bold text-lg invisible">placeholder</span>
              </div>
            )}
            
            {/* Image */}
            <div className="p-4 bg-white">
              <img
                src={deal.image}
                alt={deal.title}
                className="w-full h-48 object-contain mx-auto"
              />
            </div>

            {/* Content */}
            <div className="px-4 py-3 text-center flex-1">
              <h3 className="text-lg font-bold text-[#2C3E2D] mb-1" style={{ fontFamily: 'Heebo, sans-serif' }}>
                {deal.title}
              </h3>
              <p className="text-sm text-stone-600">
                {deal.description}
              </p>
            </div>

            {/* Price and Button */}
            <div className="p-4 bg-stone-50 text-center">
              <div className="text-3xl font-bold text-[#D97706] mb-3" style={{ fontFamily: 'Heebo, sans-serif' }}>
                {deal.price} ש"ח
              </div>
              <button
                onClick={() => handleButtonClick(deal)}
                className={`w-full flex items-center justify-center gap-2 px-6 py-3 rounded-full font-bold text-lg transition-all duration-300 ${
                  addedItems[deal.id]
                    ? 'bg-green-500 text-white hover:bg-green-600'
                    : 'bg-[#D97706] text-white hover:bg-[#B45309]'
                } hover:shadow-lg`}
                style={{ fontFamily: 'Heebo, sans-serif' }}
                data-testid={`checkout-deal-${deal.id}`}
              >
                <ShoppingCart className="w-5 h-5" />
                {addedItems[deal.id] ? 'מעבר לרכישה' : 'הוסף לסל'}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Packages;
